import Component from "@glimmer/component";
import { on } from "@ember/modifier";
import { action } from "@ember/object";
import { translateModKey } from "discourse/lib/utilities";
import dConcatClass from "discourse/ui-kit/helpers/d-concat-class";
import dIcon from "discourse/ui-kit/helpers/d-icon";
import { i18n } from "discourse-i18n";

export default class ComposerToggleSwitch extends Component {
  @action
  mouseDown(event) {
    if (this.args.preventFocus) {
      event.preventDefault();
    }
  }

  @action
  handleKeydown(event) {
    // forward events to parent handlers (like roving button bar)
    const result = this.args.onKeydown?.(event);
    if (result) {
      event.preventDefault();
    }
    return result;
  }

  get label() {
    if (this.args.state) {
      return i18n("composer.switch_to_markdown", {
        keyboardShortcut: this.keyboardShortcut,
      });
    } else {
      return i18n("composer.switch_to_rich_text", {
        keyboardShortcut: this.keyboardShortcut,
      });
    }
  }

  get keyboardShortcut() {
    return `${translateModKey("ctrl")} M`;
  }

  get ariaKeyshortcuts() {
    return this.keyboardShortcut.replace(/ /g, "+");
  }

  <template>
    {{! eslint-disable ember/template-no-pointer-down-event-binding }}
    <button
      class={{dConcatClass
        "composer-toggle-switch"
        (if @state "--rte" "--markdown")
      }}
      type="button"
      role="switch"
      disabled={{@disabled}}
      aria-checked={{if @state "true" "false"}}
      aria-label={{this.label}}
      aria-keyshortcuts={{this.ariaKeyshortcuts}}
      title={{this.label}}
      {{on "mousedown" this.mouseDown}}
      {{on "keydown" this.handleKeydown}}
      data-rich-editor={{@state}}
      ...attributes
    >
      <span class="composer-toggle-switch__slider">
        <span
          class={{dConcatClass
            "composer-toggle-switch__left-icon"
            (unless @state "--active")
          }}
          aria-hidden="true"
        >{{dIcon "fab-markdown"}}</span>
        <span
          class={{dConcatClass
            "composer-toggle-switch__right-icon"
            (if @state "--active")
          }}
          aria-hidden="true"
        >{{dIcon "a"}}</span>
      </span>
    </button>
  </template>
}
